/**
 * This file was added to avoid dependency loop so that loaded available monitors are not lost via loading
 * core-monitor package multiple times. Therefore, plugin-monitor should be included inside necessary places
 * instead core-monitor.
 */
const { serverMonitors } = require('@blaze-cms/core-monitors');

module.exports = serverMonitors;
